<template>

    <Layout>
        <PageHeader :title="title" />
        <div class="row">
            <div class="col-xxl-3">
                <div class="card">
                    <div class="card-body p-4">
                        <div v-if="isLoading">
                            <ContentLoader style="transform: scaleX(-1);">
                                <rect x="48" y="8" rx="3" ry="3" width="88" height="6" />
                                <rect x="48" y="26" rx="3" ry="3" width="52" height="6" />
                                <rect x="0" y="56" rx="3" ry="3" width="410" height="6" />
                                <rect x="0" y="72" rx="3" ry="3" width="380" height="6" />
                                <rect x="0" y="88" rx="3" ry="3" width="178" height="6" />
                                <circle cx="20" cy="20" r="20" />
                            </ContentLoader>
                        </div>
                        <div v-else>
                            <div class="mt-2 text-center mb-4">
                                <h5 class="mb-1 text-right">{{ userData.full_name }}</h5>
                                <p class="text-muted" v-if="userData.jalali_birthdate">تاریخ تولد: {{
                                        userData.jalali_birthdate
                                }}</p>
                            </div>
                            <div class="table-responsive">
                                <table class="table mb-0 table-borderless">
                                    <tbody>
                                        <tr>
                                            <th><span class="fw-medium">ایمیل</span></th>
                                            <td v-if="userData.email">{{ userData.email }}</td>
                                            <td v-else>وارد نشده</td>
                                        </tr>
                                        <tr>
                                            <th><span class="fw-medium">شماره همراه</span></th>
                                            <td>{{ userData.phone }}</td>
                                        </tr>
                                        <tr>
                                            <th><span class="fw-medium">تعداد سفارش</span></th>
                                            <td>{{ orders.length }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!--end card-body-->
                    <div v-if="false" class="card-body border-top border-top-dashed p-4">
                        <div>
                            <h6 class="text-muted text-uppercase fw-semibold mb-4">
                                Customer Reviews
                            </h6>
                            <div>
                                <div>
                                    <div class="bg-light px-3 py-2 rounded-2 mb-2">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-grow-1">
                                                <div class="fs-16 align-middle text-warning">
                                                    <i class="ri-star-fill"></i>
                                                    <i class="ri-star-fill"></i>
                                                    <i class="ri-star-fill"></i>
                                                    <i class="ri-star-fill"></i>
                                                    <i class="ri-star-half-fill"></i>
                                                </div>
                                            </div>
                                            <div class="flex-shrink-0">
                                                <h6 class="mb-0">4.5 out of 5</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center">
                                        <div class="text-muted">
                                            Total <span class="fw-medium">5.50k</span> reviews
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <div class="row align-items-center g-2">
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0">5 star</h6>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="p-1">
                                                <div class="progress animated-progess progress-sm">
                                                    <div class="progress-bar bg-success" role="progressbar"
                                                        style="width: 50.16%" aria-valuenow="50.16" aria-valuemin="0"
                                                        aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0 text-muted">2758</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end row -->

                                    <div class="row align-items-center g-2">
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0">4 star</h6>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="p-1">
                                                <div class="progress animated-progess progress-sm">
                                                    <div class="progress-bar bg-success" role="progressbar"
                                                        style="width: 29.32%" aria-valuenow="29.32" aria-valuemin="0"
                                                        aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0 text-muted">1063</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end row -->

                                    <div class="row align-items-center g-2">
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0">3 star</h6>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="p-1">
                                                <div class="progress animated-progess progress-sm">
                                                    <div class="progress-bar bg-warning" role="progressbar"
                                                        style="width: 18.12%" aria-valuenow="18.12" aria-valuemin="0"
                                                        aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0 text-muted">997</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end row -->

                                    <div class="row align-items-center g-2">
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0">2 star</h6>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="p-1">
                                                <div class="progress animated-progess progress-sm">
                                                    <div class="progress-bar bg-success" role="progressbar"
                                                        style="width: 4.98%" aria-valuenow="4.98" aria-valuemin="0"
                                                        aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0 text-muted">227</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end row -->

                                    <div class="row align-items-center g-2">
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0">1 star</h6>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="p-1">
                                                <div class="progress animated-progess progress-sm">
                                                    <div class="progress-bar bg-danger" role="progressbar"
                                                        style="width: 7.42%" aria-valuenow="7.42" aria-valuemin="0"
                                                        aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0 text-muted">408</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end row -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end card-body-->
                    <div v-if="false" class="card-body p-4 border-top border-top-dashed">
                        <h6 class="text-muted text-uppercase fw-semibold mb-4">
                            Contact Support
                        </h6>
                        <form action="#">
                            <div class="mb-3">
                                <textarea class="form-control" id="exampleFormControlTextarea1" rows="4"
                                    placeholder="Enter your messages..."></textarea>
                            </div>
                            <div class="text-end">
                                <button type="submit" class="btn btn-primary">
                                    <i class="ri-mail-send-line align-bottom me-1"></i> Send
                                    Messages
                                </button>
                            </div>
                        </form>
                    </div>
                    <!--end card-body-->
                </div>
                <!--end card-->
            </div>
            <!--end col-->

            <div class="col-xxl-9">

                <div class="row g-4 mb-3">
                    <div class="col-sm-auto">
                        <div>
                            <button v-if="!newOrderLoading" type="button" class="btn btn-success add-btn me-1"
                                data-bs-toggle="modal" id="create-btn" data-bs-target="#showModal">
                                <i class="ri-add-line align-bottom me-1"></i>
                                ثبت سفارش جدید
                            </button>
                        </div>
                    </div>
                    <div v-if="false" class="col-sm">
                        <div class="d-flex justify-content-sm-end">
                            <div class="search-box ms-2">
                                <input type="text" class="form-control" placeholder="Search Products..." />
                                <i class="ri-search-line search-icon"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div v-if="isLoading">
                            <ContentLoader style="transform: scaleX(-1);width: 600px;">
                                <circle cx="10" cy="20" r="8" />
                                <rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
                                <circle cx="10" cy="50" r="8" />
                                <rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
                                <circle cx="10" cy="80" r="8" />
                                <rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
                                <circle cx="10" cy="110" r="8" />
                                <rect x="25" y="105" rx="5" ry="5" width="220" height="10" />
                            </ContentLoader>
                        </div>
                        <div v-else class="table-card gridjs-border-none table-responsive">
                            <table class="table align-middle table-nowrap mb-0" id="customerTable">
                                <thead class="table-light">
                                    <tr>
                                        <th>سفارش</th>
                                        <th>تعداد آیتم</th>
                                        <th>قیمت</th>
                                        <th>پرداخت شده</th>
                                        <th>تاریخ ثبت</th>
                                        <th>وضعیت</th>
                                        <th>
                                            عملیات
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="list form-check-all">
                                    <tr class="gridjs-tr" v-for="(order, index) of orders" :key="index">
                                        <td data-column-id="order" class="gridjs-td">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-shrink-0 me-3">
                                                    <strong>{{ order.id }}</strong>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <h5 class="fs-14 mb-1">
                                                        {{ order.full_name }}
                                                    </h5>
                                                </div>
                                            </div>
                                        </td>
                                        <td data-column-id="items_count" class="gridjs-td">{{ order.items_count }}</td>
                                        <td data-column-id="subtotal" class="gridjs-td" v-html="order.subtotal_html">
                                        </td>
                                        <td data-column-id="total" class="gridjs-td" v-html="order.total_html"></td>
                                        <td data-column-id="published" class="gridjs-td"
                                            style="direction: ltr; text-align: right;">{{
                                                    order.jalali_order_date
                                            }}</td>
                                        <td data-column-id="status" class="gridjs-td"><span
                                                :class="`badge badge-soft-${order.status_color} text-uppercase`">{{
                                                        order.status_label
                                                }}</span>
                                        </td>
                                        <td data-column-id="action" class="gridjs-td">
                                            <a :href="order.invoice_url" target="_blank" class="btn btn-success add-btn me-1">مشاهده فاکتور</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="showModal" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered new-customer-modal">
                        <div class="modal-content">
                            <div class="modal-header bg-light p-3">
                                <h5 class="modal-title" id="exampleModalLabel">سفارش جدید</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                    id="close-modal"></button>
                            </div>
                            <form action="" @submit.prevent="submitOrder" class="row">
                                <div class="modal-body">
                                    <div class="col-lg-12">
                                        <div class="mb-3">
                                            <div class="order-new-item">
                                                <label for="products" class="form-label">انتخاب محصولات</label>
                                                <v-select v-model="products" id="products" class="form-control" label="name" :filterable="false" :options="options" multiple="" @search="onSearch">
                                                    <template v-slot:no-options>کد یکتا، نام و یا sku محصول را جستجو
                                                        کنید.</template>
                                                    <template v-slot:option="option">
                                                        <div class="search-res-option">
                                                            <img :src="option.image">
                                                            <div class="name">{{ option.name }}</div>
                                                            <div class="id">#{{ option.id }}</div>
                                                        </div>
                                                    </template>
                                                    <template v-slot:selected-option="option">
                                                        <div class="search-res-option">
                                                            <img :src="option.image">
                                                            {{ option.name }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="mb-3">
                                            <div class="order-new-item">
                                                <label for="gold_price" class="form-label">مظنه روز (تومان)</label>
                                                <input type="number" class="form-control" id="gold_price"
                                                    v-model="gold_price">
                                                <small class="text-muted" v-if="goldPriceRange">
                                                    مظنه ثبت شده در سایت: {{ goldPriceRange.gold_price.toLocaleString() }} تومان —
                                                    بازه مجاز: {{ goldPriceRange.min_gold_price.toLocaleString() }} تا
                                                    {{ goldPriceRange.max_gold_price.toLocaleString() }} تومان
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="mb-3">
                                            <div class="order-new-item">
                                                <label for="payment_method" class="form-label">روش پرداخت</label>
                                                <select class="form-control" id="payment_method"
                                                    v-model="payment_method">
                                                    <option value="bazar_pos" selected>دستگاه پوز</option>
                                                    <option value="bazar_cash">پرداخت نقدی</option>
                                                    <option value="bazar_card">کارت به کارت</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="mb-3">
                                            <div class="order-new-item">
                                                <label for="fname" class="form-label">نام مشتری</label>
                                                <input type="text" class="form-control" id="fname" v-model="fname">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="mb-3">
                                            <div class="order-new-item">
                                                <label for="lname" class="form-label">نام خانوادگی مشتری</label>
                                                <input type="text" class="form-control" id="lname" v-model="lname">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="mb-3">
                                            <div class="order-new-item">
                                                <label for="phone" class="form-label">شماره تماس مشتری</label>
                                                <input type="text" class="form-control" id="phone" v-model="phone" readonly>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-12">
                                        <div class="hstack gap-2 justify-content-end">
                                            <button type="button" id="closemodal" class="btn btn-light" data-bs-dismiss="modal" ref="closeSubmitOrder">لغو</button>
                                            <button type="submit" class="btn btn-primary"> ثبت سفارش</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="panel-spinner-overlay" v-if="newOrderLoading">
                                    <b-spinner variant="warning"></b-spinner>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

        </div>
        <!--end row-->
    </Layout>
</template>

<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import { ContentLoader } from 'vue-content-loader'
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import UserService from "@/services/user.service";

export default {
    page: {
        title: "پروفایل کاربر",
    },
    components: {
        Layout,
        PageHeader,
        ContentLoader,
        vSelect
    },
    data() {
        return {
            title: "پروفایل مشتری",
            isLoading: true,
            newOrderLoading: true,
            page: 1,
            perPage: 10,
            pages: [],
            orders: [],
            userData: '',
            options: [],
            fname: '',
            lname: '',
            phone: '',
            payment_method: '',
            gold_price: '',
            goldPriceRange: null,
            products: null
        };
    },
    computed: {
    },
    created() {
        this.getUserData(this.$route.params.user_id);
        this.getGoldPrice();
    },
    methods: {
        getGoldPrice() {
            return UserService.BranchGoldPrice()
                .then((response) => {
                    this.goldPriceRange = response.data;
                    this.gold_price = response.data.gold_price;
                });
        },
        getUserData(user_id) {
            UserService.getCustomer({user_id})
            .then((response) => {
                const { data } = response;
                this.orders = Array.isArray(data.orders) ? data.orders : [];
                delete data.orders;
                this.userData = data;
                this.fname = this.userData.first_name;
                this.lname = this.userData.last_name;
                this.phone = this.userData.phone;
            }).catch(() => {
            }).then(() => {
                this.isLoading = false;
                this.newOrderLoading = false;
            });
        },

        submitOrder() {
            this.newOrderLoading = true;
            let products = this.products.map(obj => obj.id)
            let has_error = false;
            if (!this.products.length) {
                has_error = true;
                this.$notify({
                    title: 'خطا',
                    text: 'محصولی انتخاب نشده است.',
                    type: 'error',
                });
            }
            if (!this.fname.length) {
                has_error = true;
                this.$notify({
                    title: 'خطا',
                    text: 'نام مشتری وارد نشده است.',
                    type: 'error',
                });
            }
            if (!this.payment_method.length) {
                has_error = true;
                this.$notify({
                    title: 'خطا',
                    text: 'روش پرداخت انتخاب نشده است.',
                    type: 'error',
                });
            }
            if (!this.lname.length) {
                has_error = true;
                this.$notify({
                    title: 'خطا',
                    text: 'نام خانوادگی مشتری وارد نشده است.',
                    type: 'error',
                });
            }
            if (!this.lname.length) {
                has_error = true;
                this.$notify({
                    title: 'خطا',
                    text: 'شماره مشتری وارد نشده است.',
                    type: 'error',
                });
            }
            if (has_error) {
                this.newOrderLoading = false;
                return false;
            }
            return new Promise((resolve) => {
                UserService.BranchOrderSubmit({
                    products: products,
                    fname: this.fname,
                    lname: this.lname,
                    phone: this.phone,
                    payment_method: this.payment_method,
                    gold_price: this.gold_price
                })
                    .then((response) => {
                        resolve(response);
                        this.$notify({
                            title: response.data.message,
                            type: 'success',
                        });
                        this.$refs.closeSubmitOrder.click();
                        this.isLoading = true;
                        this.getUserData(this.$route.params.user_id);
                    }, (error) => {
                        this.$notify({
                            title: "خطا",
                            text: error.message,
                            type: 'error',
                        });
                    })
                    .then(() => {
                        this.newOrderLoading = false;
                    });
            });
        },

        onSearch(search, loading) {
            if (search.length > 3) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            UserService.BranchProductSearch({'key': search})
                .then((response) => {
                    const { data } = response;
                    vm.options = Array.isArray(data) ? data : (data.items || []);
                    loading(false);
                });
        }
    },
};
</script>

